import styled from "styled-components";

export const Wrapper = styled.div`
  .action {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .reject {
    padding: 4px 22px;
    color: #ff2828;
    font-weight: 700;
    border: 1px solid #ff2828 !important;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    border-radius: 3px;
    word-break: normal;
  }
  .viewButton{
    text-transform: none;
    color: #5D78FF;
    font-size: 14px;
    font-weight: 600;
  }

  .user-profile-link{
    color: #5D78FF;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    gap: 5px;
    .user-name{
      font-style: bold;
      font-weight: 600;
      font-size: 16px;
    }
    .user-id{
      font-style: italic;
      font-size: 14px;
    }
  }
  .name-tags-container{
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    .scammer-tags{
      display: flex;
      flex-direction: row;
      gap: 5px;
    }
  }
`;

export const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 16px;
  h3 {
    margin-top: 10px;
    text-align: center;
  }
  .closeButton{
    position: absolute;
    right: 20px;
    top: 20px;
    background-color: #ffd3d3;
    padding: 10px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  .three-dot {
    width: 100%;
    position: static;
    height: 300px;
  }
  .tableContainer {
    width: 100%;
  }
  .modalTable {
    height: auto;
    overflow: auto;
    min-width: 1900px;
    width: auto;
    margin-top: 10px;
  }
  .auctionTable {
    width: 100%;
  }
  tbody {
    display: block;
    max-height: calc(100vh - 255px);
    overflow: auto;
    margin-top: 20px;
  }
  .tableHead {
    display: flex;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.6);
    border-radius: 10px;
  }
  .table-row {
    display: flex;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 0;
    border-radius: 10px;
    border-radius: 0;
  }
  .table-row:last-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .table-row:first-child {
    margin-top: 0px;
  }
  .table-row th,
  .table-row td {
    width: 10%;
    padding: 15px 5px;
    display: block;
    justify-content: center;
    align-self: center;
    text-align: center;
    word-break: break-word;
  }
  .dropdownButton{
    cursor: pointer;
    margin-left: 5px;
  }
  .open{
    transform: rotate(-90deg);
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }
  .close{
    transform: rotate(90deg);
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }
  .text-details{
    width: 100% !important;
    text-align: left !important;
  }
  .viewIcon{
    height: 30px;
    width: 30px;
    cursor: pointer;
  }
  .reject {
    padding: 4px 22px;
    color: #ff2828;
    font-weight: 700;
    border: 1px solid #ff2828 !important;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    border-radius: 3px;
    word-break: normal;
  }
  .rejected{
    padding: 4px 22px;
    background-color: #ff2828;
    color: white;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 1px;
    border-radius: 3px;
    word-break: normal;
  }
  @media (max-width: 768px) {
    tbody {
      max-height: 40vh;
    }
  }
`;
